document.addEventListener('DOMContentLoaded', () => {
    const triggers = document.querySelectorAll('.meal-modal-trigger');
    const modals = document.querySelectorAll('.meal-modal');
    const closeButtons = document.querySelectorAll('.meal-modal-close');
    const mealModalBody = document.body;
    let mealModalScrollPosition = 0;  

    triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', (event) => {
            event.stopPropagation();  
            mealModalScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            modals.forEach(modal => modal.classList.remove('dialog-visible'));
            modals[index].classList.add('dialog-visible');
            mealModalBody.style.position = 'hidden';  
        });
    });
 
    closeButtons.forEach((button, index) => {
        button.addEventListener('click', (event) => {
            modals[index].classList.remove('dialog-visible');
            mealModalBody.style.overflow = '';
            if (modals[index].classList.contains('meal-modal')) {
                window.scrollTo(0, mealModalScrollPosition);
            }
        });
    });

   dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
        dialog.classList.remove('dialog-visible');
        dialog.classList.add('dialog-hidden');
        window.scrollTo(0, mealModalScrollPosition);
    }
});
});
